<div class="lcl-select-voyage" [ngClass]="{ 'is-selected': isItemsSelected }">
  <div class="row d-none d-xl-flex">
    <div class="col-1 lcl-select-voyage-col-radio">
      <app-radio-button
        name="voyageId"
        [id]="'voyageId-' + voyage.id"
        [control]="voyageIdControl"
        [value]="voyage.id"
        [hideLabel]="true"
      ></app-radio-button>
    </div>

    <div class="col-5 pl-0">
      <div class="d-flex justify-content-between">
        <div>
          <h3>{{ "LABELS.ETD" | translate }}</h3>
          <p>{{ voyage.estimatedDepartureTime | customDateByUtc }}</p>
        </div>

        <div class="lcl-select-voyage-arrow">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="currentColor">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.500001 9L12.7 9L7.1 14.6L8.5 16L16.5 8L8.5 -6.99382e-07L7.1 1.4L12.7 7L0.500001 7L0.500001 9Z"
                fill="black"
              />
            </svg>
          </span>
        </div>

        <div class="text-right text-xl-left">
          <h3>{{ "LABELS.ETA" | translate }}</h3>
          <p>{{ voyage.estimatedArrivalTime | customDateByUtc }}</p>
        </div>
      </div>
    </div>

    <div class="col-2 my-auto">
      <h3>{{ "LABELS.VOYAGE_NUM" | translate }}</h3>
      <span>{{ voyage.referenceNumber }}</span>
    </div>

    <div class="col-2 my-auto text-right text-left">
      <h3>{{ "LABELS.CUT_OFF_DATE" | translate }}</h3>
      <span>{{ voyage.warehouseCutoff | customDateByUtc }}</span>
    </div>

    <div class="col-12" *ngIf="isVoyageChanged && isItemsSelected">
      <div class="lcl-select-voyage-warning">
        <div><span class="icon-ic_big_a"></span></div>
        <div>
          {{ "LABELS.CHANGE_QUOTE_VOYAGE_HINT" | translate : { cutoffDate: voyage.warehouseCutoff | customDateByUtc } }}
        </div>
      </div>
    </div>
  </div>

  <div class="row d-xl-none">
    <div class="col-3 lcl-select-voyage-col-radio">
      <app-radio-button
        name="voyageId"
        [id]="'voyageId-' + voyage.id"
        [control]="voyageIdControl"
        [value]="voyage.id"
        [hideLabel]="true"
      ></app-radio-button>
    </div>

    <div class="col-9">
      <div class="row">
        <div class="col-6">
          <h3>{{ "LABELS.ETD" | translate }}</h3>
        </div>
        <div class="col-6">
          <p>{{ voyage.estimatedDepartureTime | customDateByUtc }}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <h3>{{ "LABELS.ETA" | translate }}</h3>
        </div>
        <div class="col-6">
          <p>{{ voyage.estimatedArrivalTime | customDateByUtc }}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="line-mobile"></div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <h3>{{ "LABELS.CUT_OFF_DATE" | translate }}</h3>
        </div>
        <div class="col-6">
          <p class="secondary">{{ voyage.warehouseCutoff | customDateByUtc }}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <h3>{{ "LABELS.VOYAGE_NUM" | translate }}</h3>
        </div>
        <div class="col-6">
          <p class="secondary">{{ voyage.referenceNumber }}</p>
        </div>
      </div>
    </div>

    <div class="col-12" *ngIf="isVoyageChanged && isItemsSelected">
      <div class="lcl-select-voyage-warning">
        <div><span class="icon-ic_big_a"></span></div>
        <div>
          {{ "LABELS.CHANGE_QUOTE_VOYAGE_HINT" | translate : { cutoffDate: voyage.warehouseCutoff | customDateByUtc } }}
        </div>
      </div>
    </div>
  </div>
</div>
